"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconLogicSolid = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M63 25.17H48.37a2.68 2.68 0 0 0-2.67 2.67v5.31c-4.24 0-6.51-3-9.14-6.53-2.85-3.79-6.08-8.09-12.26-8.09v-5.31a2.68 2.68 0 0 0-2.67-2.67H7a2.68 2.68 0 0 0-2.67 2.67v14.61A2.67 2.67 0 0 0 7 30.5h14.63a2.67 2.67 0 0 0 2.67-2.67v-5.3c4.19 0 6.45 3 9.06 6.49a25.79 25.79 0 0 0 5.77 6.13A25.12 25.12 0 0 0 33.58 41c-2.63 3.46-4.89 6.44-9.28 6.44v-5.3a2.67 2.67 0 0 0-2.67-2.67H7a2.67 2.67 0 0 0-2.67 2.67v14.64A2.68 2.68 0 0 0 7 59.45h14.63a2.68 2.68 0 0 0 2.67-2.67v-5.31c6.38 0 9.61-4.26 12.46-8 2.56-3.37 4.77-6.29 8.94-6.29v5.31a2.68 2.68 0 0 0 2.67 2.67H63a2.68 2.68 0 0 0 2.67-2.67V27.84A2.68 2.68 0 0 0 63 25.17z"
  })),
  height: undefined,
  width: undefined
});
IconLogicSolid.displayName = 'IconLogicSolid';
var _default = IconLogicSolid;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/logic-solid.js
// module id = 581
// module chunks = 0